import { render, staticRenderFns } from "./rich_text_editor.vue?vue&type=template&id=5deec1ff&scoped=true&"
import script from "./rich_text_editor.vue?vue&type=script&lang=js&"
export * from "./rich_text_editor.vue?vue&type=script&lang=js&"
import style0 from "./rich_text_editor.vue?vue&type=style&index=0&id=5deec1ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deec1ff",
  null
  
)

export default component.exports